import { AMP_ADD_TO_CART_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import AddToCartContainer from "component/product/V2/add-to-cart/AddToCartContainer";
import ProductBadge from "component/product/desktop-badge/ProductBadge";
import useScreenSize from "hoc/useScreenSize";
import ProductPrice from "modules/product/product-price/ProductPrice";
import dynamic from "next/dynamic";
import { useState } from "react";
import HideIf from "util/HideIf";
import { getProductImage } from "util/helper/getProductImage";
import ProductDetails from "../product-cards/ProductDetails";
import ProductImage from "../product-cards/ProductImage";
import SaveForLater from "../product-cards/SaveForLater";
import styles from "./apparelGridCard.module.scss";
const ApparelQuickAdd = dynamic(() => import(/* webpackChunkName: "apparel-quick-add" */"component/product/apparel/ApparelQuickAdd"));

interface IProps{
  product: ICompactProduct;
}

function ApparelGridCard(props: IProps) {
  const { product } = props;
  const { pickUpAvailable, shippingAvailable } = product;

  const { productHighlights } = product;
  const [isMobile] = useScreenSize();

  const [showQuickAdd, setShowQuickAdd] = useState(false);

  const showQuickAddOnHover = () => {
    if (!isMobile) {
      setShowQuickAdd(true);
    }
  };

  const getUniqueValues = (key: string) => {
    const allProductValues = product.alternateProducts.filter((el) => el.filterableAttributes?.[key]).map((el) => el.filterableAttributes?.[key]);
    return Array.from(new Set(allProductValues));
  };

  const merchandiseSizes = getUniqueValues("merchandiseSize");

  return (
    <div
      className={styles.apparel_product_container}
      id={`product-grid-card-${product.sku}`}
    >
      <div
        className={styles.apparel_image_description_container}
        onMouseEnter={showQuickAddOnHover}
        onMouseLeave={() => setShowQuickAdd(false)}
      >
        <div className={styles.apparel_image_quick_add}>
          <ProductImage
            product={product}
            productHighlights={productHighlights}
            imageWidth={350}
            imageHeight={435}
            src={getProductImage(product?.thumbnailV2, false, "ds")}
          />
          <SaveForLater product={product} />
          <HideIf show={showQuickAdd}>
            <ApparelQuickAdd product={product} />
          </HideIf>
        </div>
        <div className={styles.apparel_product_details_container}>
          <ProductDetails
            product={product}
            className={styles.apparel_product_details}
          />
          <ProductPrice
            {...product}
            productPriceClassName={styles.apparel_product_price}
            color="#000000"
            size="small"
            shortFormSavedPrice
            displayInOneLine
            corePriceSize="small"
          />
        </div>
      </div>

      <HideIf show={isMobile}>
        <div className={styles.apparel_grid_footer}>
          <div className={styles.apparel_delivery_option}>
            <ProductBadge
              product={product}
            />
          </div>
          <AddToCartContainer
            product={product}
            addingToCartLocation={
              AMP_ADD_TO_CART_LOCATIONS.HORIZONTAL_PRODUCT_CARD
            }
            classActionContainer={styles.class_action_container}
            {...{
              pickUpAvailable,
              shippingAvailable,
            }}
            showQuantity={false}
            showLabel={false}
            // showAddToCart={false}
            showSaveButton={false}
            merchandiseSizes={merchandiseSizes}
          />
        </div>
      </HideIf>

    </div>
  );
}

export default ApparelGridCard;
